/**************************************************************************************************************************************************
*   MODULE NAME     :  SearchApi
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  16-02-2021
*   DESCRIPTION     :  Search API class
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import axios from "axios";
import ApiBase from "./ApiBase";
import config from "../config.json";

class SearchApi {

    /**
     * Get All Products
     */
    static loadAllAbstractsPagination = async (searchPayload, paginationData , colSelected) => {
        let payload = { action: 'getSearchAbstractsPagination', typeId: "1", search: searchPayload, paginationData: paginationData  , colSelected : colSelected}
        const response = ApiBase.post(`${config.Backend_URL}/search`, payload);
        return response;
    }
    static loadAllAbstracts = async (searchPayload) => {
        let payload = { action: 'getSearchAbstracts', typeId: "1", search: searchPayload };
        const response = ApiBase.post(`${config.Backend_URL}/search`, payload);
        return response;
    }

    static saveSearch = async (saveSearch , searchPayload) => {
        let payload = { action: 'saveSearch', typeId: "1", search: searchPayload , titleObject : saveSearch};
        const response = ApiBase.post(`${config.Backend_URL}/abstract`, payload);
        return response;
    }

    static saveAllAbstractsCriteria = async (searchPayload) => {
        let payload = { action: 'saveAllAbstractsCriteria', typeId: "1", search: searchPayload };
        const response = ApiBase.post(`${config.Backend_URL}/abstract`, payload);
        return response;
    }

    static getAllAbstractsCriteria = async (id) => {
        let payload = { action: 'getAllAbstractsCriteria', typeId: "1", id: id };
        const response = ApiBase.post(`${config.Backend_URL}/search`, payload);
        return response;
    }

    static deleteAllAbstractsCriteria = async (id) => {
        let payload = { action: 'deleteAllAbstractsCriteria', typeId: "1", id: id };
        const response = ApiBase.post(`${config.Backend_URL}/abstract`, payload);
        return response;
    }

    static loadAllSavedSearch = async () => {
        let payload = { action: 'getAllSavedSearch',typeId: "1"};
        const response = ApiBase.post(`${config.Backend_URL}/search`, payload);
        return response;
    }
    static getSearchCriteria = async (id) => {
        let payload = { action: 'getSearchCriteria',typeId: "1" ,id :id};
        const response = ApiBase.post(`${config.Backend_URL}/search`, payload);
        return response;
    }

    static inactiveSaveSearch = async (ids) => {
        let payload = { action: 'inactiveSavedSearch',typeId: "1" ,id :ids};
        const response = ApiBase.post(`${config.Backend_URL}/abstract`, payload);
        return response;
    }
     
    static checkSavedSearchtitleDuplicate = async (title) => {
        let payload = { action: 'checkSavedSearchtitleDuplicate',typeId: "1" ,title :title};
        const response = ApiBase.post(`${config.Backend_URL}/abstract`, payload);
        return response;
    }
}

export default SearchApi;
